import { FAVORITES_STORAGE_KEY } from '../../../constants';

/**
 * Codifica o conteúdo salvo da carteira para o parâmetro ?backup= da URL
 * (base64 seguro para URL, sem padding).
 *
 * O formato precisa continuar igual para que links de backup antigos funcionem:
 * o texto salvo no localStorage é serializado de novo com JSON.stringify antes do base64.
 */
export function encodeBackup(storedFavorites: string | null): string {
  const base64 = btoa(JSON.stringify(storedFavorites));

  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

/** Faz o caminho inverso de encodeBackup e devolve o texto a gravar no localStorage. */
export function decodeBackup(param: string): string {
  let base64 = param
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  // base64 precisa ter tamanho múltiplo de 4
  while (base64.length % 4) {
    base64 += '=';
  }

  return String(JSON.parse(atob(base64)));
}

export const createBackupLink = () => {
  try {
    const encoded = encodeBackup(localStorage.getItem(FAVORITES_STORAGE_KEY));

    return `${window.location.origin}${window.location.pathname}?backup=${encoded}`;
  } catch (err) {
    return null;
  }
};
